import React from "react";
import {
  compose,
  withStateHandlers,
  withHandlers,
  withPropsOnChange,
  branch,
  renderNothing,
} from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import { Page, FormGroup, SaveButton, InputGroup, onMount, required } from "components/common";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import Select from "react-select";

const isInt = (v, options = { min: 0 }) => validator.isInt(`${v}`, options);
const isNumber = (v) =>
  validator.isFloat(`${v}`, { min: 0 }) &&
  validator.isDecimal(`${v}`, { decimal_digits: "0,2" });

export const GlobalSettings = ({
  onSubmit,
  onUpdate,
  onChange,
  form,
  item,
  setDispatch,
  accounts,
  t,
  dispatch,
  ...props
}) => (
  <Page title="Settings">
    <LocalForm
      onUpdate={onUpdate}
      onSubmit={onSubmit}
      initialState={item}
      onChange={onChange}
      getDispatch={setDispatch}
      validators={{
        accounting_monthly_cost: { isNumber },
        accounting_annual_cost: { isNumber },
        payroll_monthly_cost: { isNumber },
        payroll_annual_cost: { isNumber },
        suspend_days: { isInt },
        payment_receiving_account_code: {
          required,
        }
      }}
    >
      <FormGroup
        model=".accounting_monthly_cost"
        label="Accounting Monthly Subscription Cost *"
      >
        <InputGroup suffixText="SAR">
          <Control.text model=".accounting_monthly_cost" />
        </InputGroup>
        <p className="form-text text-muted small">
          Per connected Xero account per month
        </p>
      </FormGroup>
      <FormGroup
        model=".accounting_annual_cost"
        label="Accounting Annual Subscription Cost *"
      >
        <InputGroup suffixText="SAR">
          <Control.text model=".accounting_annual_cost" />
        </InputGroup>
        <p className="form-text text-muted small">
          Per connected Xero account per year
        </p>
      </FormGroup>
      <FormGroup
        model=".payroll_monthly_cost"
        label="Payroll Monthly Subscription Cost *"
      >
        <InputGroup suffixText="SAR">
          <Control.text model=".payroll_monthly_cost" />
        </InputGroup>
        <p className="form-text text-muted small">
          Per connected Xero account per month
        </p>
      </FormGroup>
      <FormGroup
        model=".payroll_annual_cost"
        label="Payroll Annual Subscription Cost *"
      >
        <InputGroup suffixText="SAR">
          <Control.text model=".payroll_annual_cost" />
        </InputGroup>
        <p className="form-text text-muted small">
          Per connected Xero account per year
        </p>
      </FormGroup>
      <FormGroup
        model=".suspend_days"
        label="Suspend Non-payment Accounts After *"
      >
        <InputGroup suffixText="days">
          <Control.text model=".suspend_days" />
        </InputGroup>
      </FormGroup>

      <FormGroup
        model=".payment_receiving_account_code"
        label={t("Payment Receiving Bank Account")}
        className="mt-2"
      >
        <Select
          model=".payment_receiving_account_code"
          placeholder={`${t("Select a bank account")}`}
          options={accounts || []}
          Isclearable={false}
          value={item?.payment_receiving_account_code || ''}
          onChange={(e) => dispatch(actions.change('local.payment_receiving_account_code', e.value))}
        />
      </FormGroup>
      
      <div className="form-group mt-4">
        <SaveButton className="float-left" form={form} />
      </div>
    </LocalForm>
  </Page>
);

export const enhance = compose(
  withStateHandlers(
    {},
    {
      onChange: () => (item) => ({ item }),
      onUpdate: () => (form) => ({ form }),
      setDispatch:
        ({ item }) =>
        (dispatch) => ({ dispatch }),
    }
  ),
  onMount(
    ({ client, }) =>
      () =>
        Promise.props({
          accounts: client
            .get("/global_settings/xero-accounts", {
              params: {
                query: {
                  page: 1,
                  raw: "Type==\"BANK\"",
                  Type: "BANK",
                }
              } 
            })
            .get("data")
            .then((d) => d.map(item => ({ value: item.AccountID, label: item.Name}))),
        })
  ),
  withPropsOnChange([], ({ client, onChange }) => {
    client.get("/global_settings").tap((resp) => onChange(resp.data));
  }),
  branch((props) => !props.item, renderNothing),
  withHandlers({
    onSubmit:
      ({ dispatch, client }) =>
      (item) => {
        dispatch(actions.setPending("local"));

        return client
          .patch(`/global_settings/${item.id}`, item)
          .tap(({ data }) => {
            NotificationManager.success("Saved successfully");
          })
          .finally(() => dispatch(actions.setSubmitted("local")));
      },
  })
);

export default enhance(GlobalSettings);
